import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/** Об'єднує Tailwind-класи з нормалізацією конфліктів. shadcn-vue convention. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
